import React, { useEffect, useState } from "react";
import { Table, Thead, Tr, Th, Tbody, Td } from "@locus-taxy/neo-ui";
import { Button, Result, Spin, Pagination, Tag } from "antd";
import { EditOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import queryString from "query-string";
import { useLocation, useNavigate } from "react-router-dom";
import AddGroupModal from "./AddGroupModal";
import { pageGroupsFetch } from "../../redux/action/groupActions";
import {
  useCreateGroupMutation,
  useUpdateGroupMutation,
} from "../../app/services/lily";
import { updateLoader } from "../../redux/action/loaderAction";
import { defaultGroup } from "../../helpers/constant";

export const GroupTable = ({ openNotificationWithIcon }) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const data = useSelector((state) => state?.groups?.pageGroups);
  const total = useSelector((state) => state?.groups?.totalCount);
  const isLoading = useSelector((state) => state?.loader?.genericLoading);

  const { clientId, authToken } = queryString.parse(location.search);

  const [selectedRows, setSelectedRows] = useState([]);
  const [visible, setVisible] = useState(false);
  const [maxConfigurations, setMaxConfigurations] = useState(0);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(15);
  const [isRefresh, setIsRefresh] = useState(true);
  const [showAllSlots, setShowAllSlots] = useState(
    data.map(() => Array(2).fill(false))
  );

  const [
    updateGroup,
    {
      isLoading: isUpdating,
      data: updateGroupData,
      error: updateGroupError,
      isError: isUpdateGroupError,
      isSuccess: isUpdateGroupSuccess,
    },
  ] = useUpdateGroupMutation();

  const [
    createGroup,
    {
      isLoading: isCreating,
      data: createGroupData,
      error: createGroupError,
      isError: iscreateGroupError,
      isSuccess: iscreateGroupSuccess,
    },
  ] = useCreateGroupMutation();

  const handleAddGroup = (data) => {
    const editGroupTrips = data.trips.map((trip) => {
      return {
        ...trip,
        trip_slots: trip.trip_slots.map((element) => {
          return JSON.parse(element);
        }),
      };
    });

    data.trips = editGroupTrips;

    if (selectedRows.length) {
      updateGroup({
        clientId,
        authToken,
        reqBody: data,
        id: selectedRows?.[0]?.groupId,
      });
    } else {
      createGroup({ clientId, authToken, reqBody: data, id: total + 1 });
    }
  };

  useEffect(() => {
    let max = 0;
    data.forEach((group) => {
      if (group.trips.length > max) {
        max = group.trips.length;
      }
    });
    setShowAllSlots(data.map(() => Array(max).fill(false)));
    setMaxConfigurations(max);
  }, [data]);

  useEffect(
    () => {
      if (isRefresh) {
        setPage(1);
        const filter = {
          page: 1,
          size: pageSize,
        };

        dispatch(
          pageGroupsFetch(
            { clientId, authToken },
            filter,
            navigate,
            handleError
          )
        );
        setIsRefresh(false);
      }
    }, //eslint-disable-next-line
    [isRefresh]
  );

  useEffect(
    () => {
      setPage(1);
      const filter = {
        page: 1,
        size: pageSize,
      };

      dispatch(
        pageGroupsFetch({ clientId, authToken }, filter, navigate, handleError)
      );
      setIsRefresh(false);
    }, //eslint-disable-next-line
    [pageSize]
  );

  useEffect(
    () => {
      const filter = {
        page: page,
        size: pageSize,
      };

      dispatch(
        pageGroupsFetch({ clientId, authToken }, filter, navigate, handleError)
      );
    }, //eslint-disable-next-line
    [page]
  );

  useEffect(
    () => {
      if (iscreateGroupSuccess || isUpdateGroupSuccess) {
        setVisible(false);
        setIsRefresh(true);
        openNotificationWithIcon(
          "success",
          "Group Updated Successfully",
          JSON.stringify(
            createGroupData?.message ||
              updateGroupData?.message ||
              "Group Updated Successfully"
          )
        );
      }
    }, //eslint-disable-next-line
    [iscreateGroupSuccess, isUpdateGroupSuccess]
  );

  useEffect(
    () => {
      if (!iscreateGroupError && !isUpdateGroupError) return;

      setVisible(false);
      setIsRefresh(true);
      if (createGroupError?.status === 401 || updateGroupError?.status === 401)
        navigate("/unauthorized");
      handleError([
        createGroupError?.data?.data?.message ||
          createGroupError?.data?.message ||
          updateGroupError?.data?.message ||
          updateGroupError?.data?.data?.message,
      ]);
    }, //eslint-disable-next-line
    [
      iscreateGroupError,
      createGroupError,
      navigate,
      location,
      isUpdateGroupError,
      updateGroupError,
    ]
  );

  const handleError = (error) => {
    dispatch(updateLoader({ reconLoading: false }));
    openNotificationWithIcon(
      "error",
      "Something went wrong",
      JSON.stringify(
        error?.message || error?.errorResponse?.errorMessage || error
      )
    );
  };

  const handleAction = (id = null) => {
    setSelectedRows([]);
    if (id) {
      const tourDetails = data.find((group) => group.groupId === id);
      setSelectedRows([tourDetails]);
    }
    setVisible(true);
  };

  const generateHeadings = () => {
    const headings = [];
    for (let i = 0; i < maxConfigurations; i++) {
      headings.push(<Th key={i}>Combination {i + 1}</Th>);
    }
    return headings;
  };

  const toggleShowAllSlots = (rowIndex, configIndex) => {
    setShowAllSlots((prevState) => {
      return prevState.map((row, i) => {
        if (i !== rowIndex) return row;
        return row.map((config, j) => {
          if (j !== configIndex) return config;
          return !config;
        });
      });
    });
  };

  const renderConfigurationColumn = (record, rowIndex) => {
    const configRecords = [];

    for (let i = 0; i < maxConfigurations; i++) {
      const slots = record.trips[i]?.trip_slots ?? [];
      const slotContent = slots.map((slot, index) => (
        <Tag
          key={index}
          className="slot"
          style={{ backgroundColor: "#E7E9EE" }}
        >{`${slot?.startTime} - ${slot?.endTime}`}</Tag>
      ));

      configRecords.push(
        <Td key={i} className={slots.length === 0 ? "grey-bg" : ""}>
          <div>
            <br />
            <span>
              <strong>{record?.trips?.[i]?.trip_id || "-"}</strong>
            </span>
            <br />
            {showAllSlots?.[rowIndex]?.[i]
              ? slotContent
              : slotContent.slice(0, 2)}
            {slots.length > 2 && (
              <span className="show-more-slots">
                <button
                  onClick={() => toggleShowAllSlots(rowIndex, i)}
                  style={{
                    color: "rgb(0, 114, 245)",
                    border: "none",
                    cursor: "pointer",
                  }}
                >
                  {showAllSlots?.[rowIndex]?.[i]
                    ? "Show less"
                    : `+${slots.length - 2} more`}
                </button>
              </span>
            )}
            <br />
            <>&nbsp;</>
          </div>
        </Td>
      );
    }
    return configRecords;
  };

  const renderActionButton = (record = null) => {
    return (
      <div>
        <Button
          onClick={() => handleAction(record?.groupId)}
          disabled={record?.groupId === defaultGroup.groupId}
          style={{
            color: "rgb(0, 114, 245)",
            marginRight: "5px",
            border: "none",
          }}
          icon={<EditOutlined />}
        >
          Edit Group
        </Button>
      </div>
    );
  };

  return (
    <>
      <AddGroupModal
        visible={visible}
        setVisible={setVisible}
        selectedRows={selectedRows}
        handleAddGroup={handleAddGroup}
      />
      {isLoading || isCreating || isUpdating ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <Spin size="large" />
        </div>
      ) : data.length > 0 ? (
        <>
          <h2 style={{ marginBottom: "1px" }}>Groups</h2>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "2px",
            }}
          >
            <div>
              <p>Total: {total} groups</p>
            </div>
            <div>
              <Button
                onClick={() => handleAction(null)}
                style={{
                  backgroundColor: "rgb(0, 114, 245)",
                  color: "white",
                  marginRight: "5px",
                  borderRadius: "10px",
                }}
              >
                CREATE NEW GROUP
              </Button>
            </div>
          </div>
          <div style={{ height: "80vh", overflowY: "auto", overflowX: "auto" }}>
            <Table>
              <Thead>
                <Tr>
                  <Th key="Name">Group Name</Th>
                  {generateHeadings()}
                  <Th key="action">Take Action</Th>
                </Tr>
              </Thead>
              <Tbody>
                {data.map((record, index) => (
                  <Tr key={record.groupId}>
                    <Td>{record?.groupName}</Td>
                    {renderConfigurationColumn(record, index)}
                    <Td>{renderActionButton(record)}</Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "20px",
            }}
          >
            <Pagination
              showQuickJumper
              defaultCurrent={page}
              total={total}
              size="small"
              onChange={(page, _pageSize) => {
                setPage(page);
              }}
              pageSize={pageSize}
              pageSizeOptions={[15, 25, 50, 100]}
              onShowSizeChange={(_current, size) => setPageSize(size)}
              showSizeChanger
            />
          </div>
        </>
      ) : (
        <Result
          status="warning"
          title="Groups Creation"
          subTitle="No Default Group is Present."
        />
      )}
    </>
  );
};
